const initialState = {
  isAddingClient: false,
};

const AddClientReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_CLIENT_REQUEST":
      return {
        ...state,
        isAddingClient: true,
      };
    case "ADD_CLIENT_SUCCESS":
      return {
        ...state,
        isAddingClient: false,
      };
    case "ADD_CLIENT_ERROR":
      return {
        ...state,
        isAddingClient: false,
      };
    default:
      return state;
  }
};

export default AddClientReducer;
